import type { Resource } from '../../';
export const general_closeTooltip: Resource = {"default":"Close Tooltip"};
